<template>
    <div class="meeting-list">
        <div class="list-tittle">
            <div class="tittle-left">
                <span class="list" style="width: 70px">案件监管</span>
            </div>
        </div>
        <div class="list-tittle">
            <div class="tittle-right columns-right">
                <span class="status-select">
                    <span>案件类型</span>
                    <el-select v-model="caseType" placeholder="请选择案件类型" @change="searchChangepage" clearable>
                        <el-option
                                v-for="item in typeOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </span>
                <span class="status-select">
                    <span>状态</span>
                    <el-select v-model="status" placeholder="请选择案件状态" @change="searchChangepage" clearable>
                        <el-option
                                v-for="item in statusOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </span>
                <span class="status-select">
                    <span>书记员</span>
                    <el-select v-model="clerk" placeholder="请选择案件状态" @change="searchChangepage" clearable>
                        <el-option
                                v-for="item in clerkOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </span>
                <span class="status-select">
                    <span>仲裁员</span>
                    <el-select v-model="mediator" placeholder="请选择案件状态" @change="searchChangepage" clearable>
                        <el-option
                                v-for="item in mediatorOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </span>
                <span class="status-select">
                    <el-input v-model="keyWords" placeholder="搜索申请人/被申请人/案号" clearable></el-input>
                </span>
                <span @click="seachList()" class="search-list">搜索</span>
            </div>
        </div>
        <div class="content">
            <div class="item_body">
                <el-table :data="caseList" cell-class-name = "cell-name" header-cell-class-name = 'cell-name' style="width: 100%">
                    <el-table-column prop="mediationMeetingType" label="案件类型" width="160px"></el-table-column>
                    <el-table-column prop="caseNo" label="案号"></el-table-column>
                    <el-table-column prop="clerk" label="书记员"></el-table-column>
                    <el-table-column prop="mediator" label="仲裁员"></el-table-column>
                    <el-table-column prop="mediationStatus" :formatter="formatStatus" label="状态"></el-table-column>
                    <el-table-column prop="orderTime" :formatter="formatDate" label="庭审时间"></el-table-column>
                    <el-table-column min-width ='110' label="操作">
											<template slot-scope="scope">
												<template v-if="scope.row.mediationMeetingTypeCode == case_type_code.MEDIATION_MEETING">
                            <el-button  class="btn-action" @click="checkDetail(scope.row)" type="text" size="small">查看详情</el-button>
                            <el-button  v-if =  "(scope.row.mediationStatus == 'RUNNING' || scope.row.mediationStatus == 'END')"  class="btn-action" @click="openvideodialog(scope.row.id)" type="text" size="small">视频记录</el-button>
                        </template>
												<template v-else>
                            <el-button  class="btn-action" @click="enterCaseDetail(scope.row, true)" type="text" size="small">{{ scope.row.mediationMeetingType }}</el-button>
                        </template>
											</template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="page-box" v-if= 'totalData'>
            <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="totalData"
                    :current-page.sync="curIndex"
                    :page-size="pageSize"
                    @current-change="changepage"
                    prev-text="上一页"
                    next-text="下一页">
            </el-pagination>
        </div>
				<video-record ref="comVideoRecord"></video-record>
    </div>
</template>
<script>
import videoRecord from "@/components/videoRecord";
import { monitorNewCaseList } from "@/api/case";
import { listBackstageUser } from "@/api/user";
import { caseListMixins } from "../myCase/caseListMixins";
import {
  dateformat,
  setStore,
  getUrlParams,
  getStore,
  removeStore,
  getStoreSession
} from "@/utils/utils.js";

export default {
  data() {
    return {
      curIndex: 1,
      pageSize: 10,
      totalData: 0,
      status: "",
      caseType: "",
      clerk: "",
      mediator: "",
      statusOptions: [
        {
          value: "",
          label: "全部"
        },
        {
          value: "INIT",
          label: "未开始"
        },
        {
          value: "RUNNING",
          label: "进行中"
        },
        {
          value: "END",
          label: "已结束"
        }
      ],
      clerkOptions: [],
      mediatorOptions: [],
      caseList: [],
      keyWords: "",
      caseId: null
    };
  },
  mixins: [caseListMixins],
  created() {
    if (getUrlParams().appName) {
      setStore("appName", getUrlParams().appName);
    }
  },
  components: {
    videoRecord
  },
  mounted() {
    this.caseId = getUrlParams().caseId ? getUrlParams().caseId : this.caseId;
    if (getUrlParams().token) {
      setStore("isOutter", 1);
      setStore("flk", getUrlParams().token);
      document.querySelector(".el-header").style.display = "none";
      document.querySelector(".el-aside").style.display = "none";
    }
    this.seachList();
    this.getData();
  },
  methods: {
    getData() {
      listBackstageUser({
        pageIndex: 1,
        pageSize: 1000,
        roleCode: "MEDIATOR"
      }).then(res => {
        if (res.data.code === 1000) {
          res.data.data.list.forEach(item => {
            this.mediatorOptions.push({
              value: item.userId,
              phone: item.mobilePhone,
              label: item.userName
            });
          });
        }
      });
      listBackstageUser({
        pageIndex: 1,
        pageSize: 1000,
        roleCode: "CLERK"
      }).then(res => {
        if (res.data.code === 1000) {
          res.data.data.list.forEach(item => {
            this.clerkOptions.push({
              value: item.userId,
              phone: item.mobilePhone,
              label: item.userName
            });
          });
        }
      });
    },
    seachList(page) {
      !page && (this.curIndex = 1);
      let params = {
        mediationStatus: this.status ? this.status : null,
        mediationMeetingType: this.caseType ? this.caseType : null,
        pageIndex: this.curIndex,
        pageSize: this.pageSize,
        keyword: this.keyWords ? this.keyWords : null,
        clerkId: this.clerk ? this.clerk : null,
        mediatorId: this.mediator ? this.mediator : null
      };
      monitorNewCaseList(params).then(
        res => {
          if (res.data.code === 1000) {
            let data = res.data.data;
            if (data.list && data.list.length > 0) {
              data.list.forEach(element => {
                let mtimeFlag;
                if (!element.orderTime) {
                  return;
                }
                let minutesPlus =
                  (element.orderTime - new Date().getTime()) / 60000;
                if (minutesPlus > 30) {
                  mtimeFlag = true;
                } else {
                  mtimeFlag = false;
                }
              });
            }
            this.caseList = data.list;
            this.totalData = data.totalRows;
            this.curIndex = data.pageIndex;
          } else {
            this.$message({
              type: "error",
              message: res.data.message
            });
          }
        },
        erro => {
          console.log(erro);
        }
      );
    },
    openvideodialog(meetingid) {
      this.$refs.comVideoRecord.openDialog(meetingid);
    },
    changepage(value) {
      this.curIndex = value;
      this.seachList(1);
    },
    searchChangepage() {
      this.curIndex = 1;
      this.seachList();
    }
  }
};
</script>
<style lang="scss">
.el-message-box__wrapper {
  .el-message-box.book_quit {
    width: 440px;
    text-align: center;
    position: relative;
    .el-message-box__header {
      border-bottom: 1px solid #e5e5e5;
      padding: 20px 35px 10px;
      font-size: 16px;
      color: #666;
      text-align: left;
      padding-left: 40px;
      &:before {
        content: "";
        position: absolute;
        display: inline-block;
        left: 26px;
        top: 18px;
        width: 4px;
        height: 20px;
        background: #0083c8;
      }
    }
    .el-message-box__btns {
      text-align: center;
      .book_button_primary_small {
        color: #fff;
        margin-left: 30px;
      }
      .book_button_default_small {
        background: #fff;
        color: #0083c8;
      }
      .el-button {
        width: 150px;
        height: 50px;
      }
    }
  }
}
.meeting-list {
  .list-tittle {
    width: 100%;
    height: 60px;
    background: #fff;
    overflow: hidden;
    line-height: 60px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    .columns-right {
        width: 100%;
    }
    .tittle-left {
      .lauch-list {
        cursor: pointer;
        font-size: 14px;
        display: inline-block;
        border-radius: 4px;
        margin-left: 20px;
        width: 80px;
        height: 30px;
        line-height: 30px;
        border: 1px solid #0083c8;
        color: #0083c8;
        text-align: center;
        &:hover {
          color: #fff;
          background: #0083c8;
        }
      }
      margin-left: 20px;
      font-size: 16px;
      color: #333333;
      .list {
        display: inline-block;
        margin-right: 20px;
      }
      .el-button {
        height: 30px;
        width: 96px;
        line-height: 5px;
        border-radius: 4px;
        border: solid 1px #0083c8;
        color: #0083c8;
        &:hover {
          color: #fff;
          background: #0083c8;
        }
      }
    }
    .tittle-right {
      display: flex;
      margin-right: 20px;
      .status-select {
        display: flex;
          flex-grow: 1;
          margin-left: 20px;
        span {
            flex-shrink: 0;
            flex-grow: 0;
          font-size: 15px;
          color: #606266;
          margin-right: 10px;
        }
      }
      .search-list {
        cursor: pointer;
        font-size: 14px;
        display: inline-block;
        border-radius: 4px;
        margin-left: 20px;
        width: 80px;
        height: 30px;
        margin-top: 14px;
        line-height: 30px;
        border: 1px solid #0083c8;
        color: #0083c8;
        text-align: center;
        &:hover {
          color: #fff;
          background: #0083c8;
        }
      }
    }
  }
  .item_body {
    margin-top: 10px;
    .cell-name {
      text-align: center;
    }
    .btn-action {
      font-size: 14px;
    }
  }
  .page-box {
    background: #fff;
    text-align: center;
    padding: 40px 0 40px;
    li {
      padding: 0;
      border: none;
    }
  }
}
</style>
